<template>
    <div class="confirmation-modal">
        <div class="listing-modal-wrapper">
            <div class="logout-modal-wrapper">
                <div class="modal fade show"
                     tabindex="-1" role="dialog"
                     aria-labelledby="exampleModalCenterTitle"
                     aria-hidden="true"
                     style="display: block"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4>{{ $t('addonConfirmationModal.title') }}</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                                    <span class="close-span" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="confirmation-modal-body modal-body">
                                <div class="addon-confirmation-reports" v-if="reports && (reports.contract || reports.terms)">
                                    <a v-if="reports.contract"
                                       :href="reports.contract.url"
                                       class="contract-pdf-link"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                    >
                                        {{ $t('addonConfirmationModal.contractLink') }}
                                    </a>
                                    <a v-if="reports.terms"
                                       :href="reports.terms.url"
                                       class="contract-pdf-link"
                                       target="_blank"
                                       rel="noopener noreferrer"
                                    >
                                        {{ $t('addonConfirmationModal.termsLink') }}
                                    </a>
                                </div>
                                <div class="addon-confirmation-checkbox">
                                    <label>
                                        <input type="checkbox" v-model="agreed" />
                                        {{ $t('addonConfirmationModal.termsCheckbox') }}
                                    </label>
                                </div>
                                <div id="modal-buttons">
                                    <button type="button"
                                            class="btn btn-red"
                                            :disabled="!agreed"
                                            @click="agreeTerms"
                                    >
                                        {{ $t('logoutModal.buttons.yes') }}
                                    </button>
                                    <button type="button"
                                            class="btn btn-light"
                                            @click="close"
                                    >
                                        {{ $t('logoutModal.buttons.no') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddonConfirmationModal from './AddonConfirmationModal';
export default AddonConfirmationModal;
</script>

<style scoped>
.addon-confirmation-reports {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}
.contract-pdf-link {
    display: inline-block;
    margin-top: 6px;
    padding: 4px 12px;
    border: 1px solid currentColor;
    border-radius: 4px;
    font-size: 0.85em;
    text-decoration: none;
}
.contract-pdf-link:hover {
    text-decoration: none;
    opacity: 0.8;
}
</style>
